import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { Button, Container, Form, Input } from "reactstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { gstinPattern } from "../../../../../variables/constants";

function AdminUpdateUserProfile({
  isModalShow,
  onClose,
  handleUpdateProfile,
  userStatus,
  setUserStatus,
  gstValid,
  setGstValid,
}) {
  return (
    <Transition.Root show={isModalShow} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        // initialFocus={cancelButtonRef}
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <Container
          className="fixed inset-0 z-10 overflow-y-auto mt-10"
          // onClick={onClose}
        >
          <div className="flex items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <Container className="flex justify-between items-center">
                  <p className="ml-5 text-lg font-semibold">Update Profile</p>
                  <Dialog.Title
                    as="button"
                    onClick={onClose}
                    className="text-lg font-medium leading-6 text-gray-900 text-right p-5 outline-none"
                  >
                    <AiOutlineCloseCircle />
                  </Dialog.Title>
                </Container>

                <Form onSubmit={handleUpdateProfile} className="mx-6">
                  <Box
                    sx={{
                      maxWidth: "100%",
                    }}
                  >
                    <Container className="px-4 mb-4">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={
                          userStatus.user_type == 1
                            ? "1"
                            : userStatus.user_type == 2
                            ? "2"
                            : ""
                        }
                        name="radio-buttons-group"
                        className="flex !flex-row gap-7"
                      >
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              sx={{
                                color: "#800000",
                                "&.Mui-checked": {
                                  color: "#800000",
                                },
                              }}
                              onChange={(e) => {
                                setUserStatus({
                                  ...userStatus,
                                  user_type: e.target.value,
                                });
                              }}
                            />
                          }
                          label="Individual"
                          sx={{
                            marginRight: "0",
                            "& .MuiTypography-root": {
                              fontFamily: "Poppins",
                            },
                          }}
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              sx={{
                                color: "#800000",
                                "&.Mui-checked": {
                                  color: "#800000",
                                },
                              }}
                              onChange={(e) => {
                                setUserStatus({
                                  ...userStatus,
                                  user_type: e.target.value,
                                });
                              }}
                            />
                          }
                          label="Corporate"
                          sx={{
                            marginRight: "0",
                            "& .MuiTypography-root": {
                              fontFamily: "Poppins",
                            },
                          }}
                        />
                      </RadioGroup>
                    </Container>

                    {userStatus.user_type == 2 && (
                      <TextField
                        fullWidth
                        name="company_name"
                        label="Enter a Company name"
                        id="fullWidth"
                        type="company_name"
                        sx={{
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins",
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins",
                          },
                          "& .MuiOutlinedInput-root": {
                            fontFamily: "Poppins",
                            borderRadius: "12px",
                          },
                          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#800000",
                            },
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#800000",
                            },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid #800000",
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#800000",
                          },
                          marginBottom: "20px",
                        }}
                        value={userStatus.company_name}
                        onChange={(e) =>
                          setUserStatus({
                            ...userStatus,
                            company_name: e.target.value,
                          })
                        }
                      />
                    )}

                    {(userStatus.user_type == 1 ||
                      userStatus.user_type == 2) && (
                      <TextField
                        fullWidth
                        name="gst_no"
                        label="Enter a GST no. (e.g., 07AAAAA0000A1Z5)"
                        id="fullWidth"
                        type="gst_no"
                        sx={{
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins",
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins",
                          },
                          "& .MuiOutlinedInput-root": {
                            fontFamily: "Poppins",
                            borderRadius: "12px",
                          },
                          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#800000",
                            },
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "#800000",
                            },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid #800000",
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#800000",
                          },
                          marginBottom: "20px",
                        }}
                        value={userStatus.gst_no}
                        onChange={(e) => {
                          // Auto-convert to uppercase
                          const upperValue = e.target.value.toUpperCase();
                          setUserStatus({ ...userStatus, gst_no: upperValue });

                          //  Validate
                          if (upperValue.trim().length === 0) {
                            setGstValid(true);
                          } else {
                            setGstValid(gstinPattern.test(upperValue.trim()));
                          }
                        }}
                      />
                    )}

                    <Container className="flex justify-end items-center mb-5">
                      <Button
                        type="submit"
                        className="px-8 py-2 bg-[#800000] text-white font-semibold rounded-lg active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
                      >
                        Update
                      </Button>
                    </Container>
                  </Box>
                </Form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Container>
      </Dialog>
    </Transition.Root>
  );
}

export default AdminUpdateUserProfile;
